<template>
    <div>
        <el-dialog title="图片预览" :visible="img_show" width="50%"  top="5vh" @close="imageClose" @opened="previewImage">
            <div style="text-align: center;">
                <div v-if="previewLoading" class="loading-container">
                    <i class="el-icon-loading"></i>
                    <p>加载中...</p>
                </div>
                <img v-if="previewImageUrl" style="max-height: 700px;" :src="previewImageUrl" alt="">
                <!-- <div v-else class="error-container">
                    <i class="el-icon-picture-outline"></i>
                    <p>图片加载失败</p>
                </div> -->
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="downloadFile" size="small">下载</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { viewFileApi } from '@/Api/fileApi'
export default {
    name: 'imageView',
    props: {
        img_show: {
            type: Boolean,
            default: false,
        },
        filePath: {
            type: String,
            default: ''
        },
        fileName: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            previewLoading: false,
            previewImageUrl: '',
        }
    },
    methods: {
        imageClose() {
            // 清理Blob URL避免内存泄漏
            if (this.previewImageUrl) {
                URL.revokeObjectURL(this.previewImageUrl);
                this.previewImageUrl = "";
            }
            this.$emit('imageClose', '')
        },
        previewImage() {
            if (this.previewImageUrl) {
                URL.revokeObjectURL(this.previewImageUrl);
                this.previewImageUrl = ''
            }
            this.previewLoading = true;
            viewFileApi(this.filePath, this).then(blob => {
                this.previewLoading = false;
                this.previewImageUrl = URL.createObjectURL(blob)
            }).catch(() => {
                this.previewLoading = false;
            })
        },
        downloadFile() {
            if (!this.fileName || !this.filePath) {
                this.$alert('文件参数缺失，无法下载', '数据异常', { type: 'error' })
                return
            }
            viewFileApi(this.filePath, this).then(blob => {
                // 创建下载链接
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = this.fileName;
                document.body.appendChild(a);
                a.click();

                // 清理
                setTimeout(() => {
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }, 100);

                this.$message.success(`开始下载: ${this.fileName}`);
            }).catch(() => {
                this.$message.error("文件下载失败，请重试");
            })
        },
    },
    mounted() {
        // this.previewImage()
    },
}
</script>